import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { useAppContext } from '@icp/app';
import { useReadonly } from '../NodeContextProvider';

const PageRenderer = loadable(() =>
  import(
    // eslint-disable-next-line import/no-unresolved
    '@icp/page-renderer'
  ).catch(() => ({
    default: function ErrBoundary() {
      console.error(`"@icp/page-renderer" not installed`);
      return null;
    },
  })),
);

function SettingForm(props) {
  const { data, pbcToken, pageToken, onChange } = props;

  const { contextFromAppProp } = useAppContext();
  const readonly = useReadonly();

  return (
    <PageRenderer
      schemaId={pageToken}
      FormRendererProps={{
        readonly,
        defaultData: data,
        onChange,
      }}
      context={contextFromAppProp}
      pbcToken={pbcToken}
    />
  );
}

SettingForm.propTypes = {
  data: PropTypes.shape({}),
  pbcToken: PropTypes.string,
  pageToken: PropTypes.string,
  onChange: PropTypes.func,
};

export default SettingForm;
